
export interface IMaterialState {
    getAllMaterialStockSuccess : any;
    getAllMaterialStockError : any;
    getAllMaterialSuccess : any;    
    getAllMaterialError : any;
    getAllMaterialsByCompanyIdSuccess : any;
    getAllMaterialByCompanyIdError : any;
    getMaterialsByStatusIdSuccess : any;
    getMaterialsByStatusIdError : any;
    getMaterialsByAgentIdSuccess : any;
    getMaterialsByAgentIdError : any;
    getAddMaterialSuccess : any;
    getAddMaterialError : any;
    importMaterialSuccess : any;
    importMaterialError : any;
    getEditMaterialSuccess : any;
    getEditMaterialError : any;
    getMaterialCodeSuccess: any;
    getMaterialCodeError: any;
    inActivateMaterialSuccess : any;
    inActivateMaterialError: any;
    getMatInventorySuccess: any;
    getMatInventoryError: any;
    getAddTypeSuccess: any;
    getAddTypeError: any;
    getAddUOMSuccess : any;
    getAddUOMError: any;
    getAddAlergensSuccess: any;
    getAddAlergensError: any;
    getSubGroupTypeSuccess : any;
    getSubGroupTypeError:  any;

    //ImportSheet
    getImportExcelSheetSuccess : any;
    getImportExcelSheetError : any;

}

export const initialMaterialState : IMaterialState =  {
    getAllMaterialStockSuccess : null,
    getAllMaterialStockError : null,
    getAllMaterialSuccess : null,    
    getAllMaterialError : null,
    getAllMaterialsByCompanyIdSuccess : null,
    getAllMaterialByCompanyIdError : null,
    getMaterialsByStatusIdSuccess : null,
    getMaterialsByStatusIdError : null,
    getMaterialsByAgentIdSuccess : null,
    getMaterialsByAgentIdError : null,
    getAddMaterialSuccess : null,
    getAddMaterialError : null,
    importMaterialSuccess : null,
    importMaterialError : null,
    getEditMaterialSuccess : null,
    getEditMaterialError : null,
    getMaterialCodeSuccess: null,
    getMaterialCodeError: null,
    inActivateMaterialSuccess : null,
    inActivateMaterialError: null,
    getMatInventorySuccess: null,
    getMatInventoryError: null,
    getAddTypeSuccess:null,
    getAddTypeError: null,
    getAddUOMSuccess :  null,
    getAddUOMError: null,
    getAddAlergensSuccess: null,
    getAddAlergensError: null,
    getSubGroupTypeSuccess : null,
    getSubGroupTypeError: null,

      //ImportSheet
      getImportExcelSheetSuccess : null,
      getImportExcelSheetError : null,
}